import SAMAN_CONFIG from "./global-config";
import NotificationStore from "./components/NotificationPlugin/NotificationStore";
import { forceLogout } from "./utils/authStorageManager";

function fetchErrorHandler(code, message, component) {
  console.log(
    "[Fetch Error]: " +
    code +
    " - " +
    message +
    " - in " +
    component +
    " component"
  );
  if (code === 401 && !SAMAN_CONFIG.enableSSO) {
    forceLogout();
  } else if (code === 500) {
    NotificationStore.notify({
      message: "Server encountered error while processing this request!",
      icon: "error",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "danger",
    });
  }
}

export { fetchErrorHandler as default };
